export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=a5f2d884&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/leads/index.vue?vue&type=template&id=a5f2d884&
// module id = 1151
// module chunks = 0